import { Icon as n } from "./index.es7.js";
import "./index.es33.js";
var e = [{
  name: "Recent",
  icon: n.icons.outline.clock
}, {
  name: "Smileys & Emotion",
  icon: n.icons.outline.smile
}, {
  name: "Animals & Nature",
  icon: n.icons.outline.cat
}, {
  name: "Food & Drink",
  icon: n.icons.outline.burger
}, {
  name: "Travel & Places",
  icon: n.icons.outline.airplane
}, {
  name: "Activities",
  icon: n.icons.outline.football
}, {
  name: "Objects",
  icon: n.icons.outline.lamp
}, {
  name: "Symbols",
  icon: n.icons.outline.peace
}, {
  name: "Flags",
  icon: n.icons.outline.flag
}];
export { e as EMOJI_CATEGORIES };